export function DateTimeFormatter(dateStr) {
  dateStr = dateStr.replace(",", " ");
  let date = dateStr.split(" ")[0];
  let items = date.split("/");
  items.map((item, i) => {
    if (item.length === 1) {
      items[i] = "0" + items[i];
    }
    return item;
  });

  return items.join("/");
}

export function ParseYMDwDash(dateString) {
  dateString = dateString.split("T")[0];

  var dateItems = dateString.split("-");
  var formattedDate = dateItems[2] + "/" + dateItems[1] + "/" + dateItems[0];

  return formattedDate;
}

export function ParseDMYwSlashes(dateString) {
  var dateItems = dateString.split("/");
  var formattedDate = dateItems[2] + "-" + dateItems[1] + "-" + dateItems[0];

  var finalDate = new Date(formattedDate);

  return finalDate;
}

export function calcDiffInDays(date1, date2) {
  var timeDiff = Math.abs(date2.getTime() - date1.getTime());
  var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
  return diffDays;
}

export function createCustomDateString1() {
  var now = new Date();
  return `${now.getDate()}/${now.getMonth()}/${now.getFullYear()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
}

export function validateDateRange(date1, date2) {
  //will return false if date2 is smaller than date1

  let parsed1 = ParseDMYwSlashes(date1);
  let parsed2 = ParseDMYwSlashes(date2);

  if (
    parsed1.toString().includes("Invalid Date") ||
    parsed2.toString().includes("Invalid Date")
  ) {
    return false;
  }

  return date2 > date1;
}



// WEBPACK FOOTER //
// ./src/helpers/DateHelpers.js